<template>
    <div class="wrapper" :class="outerWrapperClass" @click.stop.prevent="edit">
        <input
            v-if="(alwaysEditing || editing) && !useTextarea"
            :autofocus="autofocus"
            ref="editable-text-input"
            :class="editInputClass"
            @blur="this.onBlur"
            @change="onInputChangeInternal"
            @keypress.enter="onEnterUp"
            @focus="onInputFocus"
            :value="text" />

        <textarea
            v-if="(alwaysEditing || editing) && useTextarea"
            v-model="originalText"
            ref="editable-text-input"
            :autofocus="autofocus"
            rows="6"
            @blur="this.onBlur"
            :class="editInputClass"
            @change="onInputChangeInternal"
            @keyup="onInputChangeInternal"
        ></textarea>

        <button
            @click.stop.prevent="onDoneClick($event)"
            :class="doneButtonClass"
            v-if="editing && (useTextarea || !doneOnBlur)">{{$t('message.done')}}</button>

        <div v-if="!alwaysEditing && !editing" class="text-span-wrapper">
            <span style="white-space: pre-line;" :style="{'cursor': editable ? 'pointer' : 'default'}" :class="allDisplayTextClass" @click="edit">{{text || placeholder}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                type: [String, Number],
                required: true
            },
            placeholder: {
                type: String,
                requried: false
            },
            'useTextarea': {
                default: false,
                type: Boolean
            },
            doneOnBlur: {
                type: Boolean,
                default: true
            },
            onChange: Function, // onChange is an optional callback for listening every changes made onto the text
            onDone: Function, // onDone is an optional callback for listening final result of edited text when user press done button,
            outerWrapperClass: String,
            doneButtonClass: String,
            editInputClass: String,
            displayTextClass: String,
            editable: {
                type: Boolean,
                default: true
            },
            alwaysEditing: {
                type: Boolean,
                default: false
            },
            selectOnFocus: {
                type: Boolean,
                default: false,
            },
            autofocus: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            allDisplayTextClass() {
                var classes = [];
                if (this.displayTextClass) {
                    classes.push(this.displayTextClass);
                }

                if (!this.text && this.placeholder) {
                    classes.push('placeholder');
                }

                return classes.join(' ');
            }
        },

        data() {
            return {
                editing: false,
                originalText: this.text
            };
        },

        updated() {
            if (this.editing) {
                this.$refs['editable-text-input'].focus();
            }
        },

        methods: {
            edit() {
                if (this.editable) {
                    this.editing = true;
                }
            },
            onDoneClick(event) {
                const value = this.$refs['editable-text-input'].value;
                if (this.onChange) {
                    this.onChange(value);
                }
                if (this.onDone) {
                    this.onDone(value);
                }
                this.editing = false;
                this.$emit('input', value);

                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            },
            onEnterUp(event) {
                this.onDoneClick(event);
            },
            onInputChangeInternal() {
                if (this.onChange) {
                    this.onChange(this.$refs['editable-text-input'].value);
                }
            },
            onBlur() {
                if (this.doneOnBlur) {
                    this.onDoneClick();
                }
            },
            resetText(text) {
                this.originalText = text;
            },
            onInputFocus() {
                if (this.selectOnFocus) {
                    this.$refs['editable-text-input'].select();
                }
            },
        }
    }
</script>

<style scoped>
    .wrapper {
        cursor: pointer;
        border-radius: 8px;
        padding: 4px 12px;
    }

    span {
        cursor: pointer;
    }

    .text-span-wrapper {
        word-break: break-word;
        display: inline-block;
    }

    .wrapper:hover {
        background-color: #F3F3F3;
        border-radius: 8px;
        transition: background-color 0.3s;
    }

    .font-icon {
        color:#adb7be;
        font-size: 14px;
    }

    .placeholder {
        color: #aaa;
    }
</style>
